import { api } from 'redux-store/api';

import {
  IInviteArgs,
  IInviteSignUpBody,
  IInviteSignUpCheckArgs,
  IInviteSignUpCheckResponse,
  IInviteSignUpResponse,
  IInvitesBulkBody,
  TInviteResponse,
  IGetCheckInviteExistence,
  TCheckInviteExistenceResponse,
  IDeleteInvitePayload,
} from './invites.types';

enum Endpoints {
  INVITES = 'invites/',
}

export const invitesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getInvites: build.query<TInviteResponse, IInviteArgs>({
      query: (queryArgs) => ({
        url: Endpoints.INVITES,
        params: queryArgs,
      }),
      providesTags: ['Invites'],
    }),

    getInviteSignUpCheck: build.query<IInviteSignUpCheckResponse, IInviteSignUpCheckArgs>({
      query: (queryArgs) => ({
        url: `${Endpoints.INVITES}invite-sign-up-check`,
        params: queryArgs,
      }),
    }),

    getCheckInviteExistence: build.query<TCheckInviteExistenceResponse, IGetCheckInviteExistence>({
      query: (queryArgs) => ({
        url: `${Endpoints.INVITES}check-invite-existence`,
        params: queryArgs,
      }),
      providesTags: ['Invite Existence'],
    }),

    invitesBulk: build.mutation<undefined, IInvitesBulkBody>({
      query: (data) => ({
        url: `${Endpoints.INVITES}bulk`,
        body: data,
        method: 'POST',
      }),
      invalidatesTags: ['Invites'],
    }),

    inviteSignUp: build.mutation<IInviteSignUpResponse, IInviteSignUpBody>({
      query: (data) => ({
        url: `${Endpoints.INVITES}invite-sign-up`,
        body: data,
        method: 'POST',
      }),
      invalidatesTags: ['User', 'Company'],
    }),

    deleteInviteById: build.mutation<void, IDeleteInvitePayload>({
      query: ({ id }) => ({
        url: `${Endpoints.INVITES}${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, error) => (!error ? ['Invite Existence'] : []),
    }),
  }),
});

export const {
  useGetInvitesQuery,
  useLazyGetInvitesQuery,
  useGetInviteSignUpCheckQuery,
  useLazyGetInviteSignUpCheckQuery,
  useInviteSignUpMutation,
  useInvitesBulkMutation,
  useGetCheckInviteExistenceQuery,
  useLazyGetCheckInviteExistenceQuery,
  useDeleteInviteByIdMutation,
} = invitesApi;
